// extracted by mini-css-extract-plugin
export var typingIndicator = "_pq-0";